<template>
	<div class="InventoryDasbardTab">
		<div style="padding:15px;">
			<el-row :gutter="20">
				<el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
					<label>
						Quick Reports
					</label>
					<el-select
						v-model="params.quickReports"
						style="width: 100%"
						placeholder="Select"
						@change="changedQuickReport(params.quickReports)"
					>
						<el-option
							v-for="(quick_report, index) in allQuickReports"
							:key="index"
							:value="quick_report.id"
							:label="quick_report.name"
							:disabled="quick_report.isDisabled"
						>
							{{ quick_report.name }}
						</el-option>
					</el-select>
					<!-- :disabled="isContributionView &&( quick_report.id == 'day' || quick_report.id == 'week' || quick_report.id == 'month' || quick_report.id == 'wow' || quick_report.id == 'mom')" -->
				</el-col>
				<el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
					<label>
						Date From
					</label>
					<el-date-picker
						v-model="params.start_date"
						type="date"
						placeholder="Select Date"
						style="width: 100%"
						@change="changedDate"
						:disabled="params.quickReports != 'sale'"
						:picker-options="datePickerOptions"
					/>
				</el-col>
				<el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
					<label>
						Date To
					</label>
					<el-date-picker
						v-model="params.end_date"
						type="date"
						placeholder="Select Date"
						style="width: 100%"
						@change="changedDate()"
						:disabled="params.quickReports != 'sale'"
						:picker-options="datePickerOptions"
					/>
				</el-col>
				<!-- <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
					<label>
						Report Type
					</label>
					<el-select
						v-model="reportTypeValue"
						style="width: 100%"
					>
						<template v-for="(view, index) in reportType">
							<el-option :key="index" :value="view.id" :label="view.name">
								{{ view.name }}
							</el-option>
						</template>
					</el-select>
				</el-col> -->
			</el-row>
		</div>
		<div>
			<!-- <el-row :gutter="40">
				<el-col :xs="12" :sm="12" :md="9" :lg="9" :xl="9">
					<label>
						location
					</label>
					<el-select
						v-model="location"
						style="width: 100%"
						placeholder="Select"
					>
						<el-option
							v-for="(outlet, index) in outlets"
							:key="index"
							:value="outlet.id"
							:label="outlet.name"
						>
							{{ outlet.name }}
						</el-option>
					</el-select>
				</el-col>
			</el-row> -->
		</div>
		<div class="mdms__parent">
			<p class="text-xs mb-1">Location</p>
			 <base-locations-dropdown class="mdms" @update="dropDownUpdate" />
			<base-categories-dropdown
				class="mdms"
				@categoryUpdate="categoryDropdownUpdate"
			/>
			<el-input
				size="medium"
				placeholder="search"
				style="width: 300px;"
				v-model="search">
			</el-input>
		</div>
	</div>
</template>
<script>
import BaseLocationsDropdown from "../../../../../components/baseLocationsDD/BaseLocationsDD";
import BaseCategoriesDropdown from "../../../../baseCategoriesDD/BaseCategoriesDD.vue";
import CommonService from "../../../../../services/commonService.js";
import InventoryService from "../../../../../services/inventoryService";
import moment from "moment";
import { EventBus } from "../../../../../eventBus";
export default {
	name: "InventoryDasbardTab",
	components: {
		BaseLocationsDropdown,
		BaseCategoriesDropdown
	},
	props: {
		params: {
			type: Object,
			default: () => {}
		},
		selectedType: {
			type: String,
			default: () => ""
		},
		locationdId: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			search:"",
			allQuickReports: [
				{
					name: "Sales",
					id: "sale",
					isDisabled: false
				},
				{
					name: "WTD",
					id: "wtd",
					isDisabled: false
				},
				{
					name: "MTD",
					id: "mtd",
					isDisabled: false
				},
				{
					name: "QTD",
					id: "qtd",
					isDisabled: false
				},
				{
					name: "YTD",
					id: "ytd",
					isDisabled: false
				},
				{
					name: "WOW",
					id: "wow",
					isDisabled: false
				},
				{
					name: "MOM",
					id: "mom",
					isDisabled: false
				}
			],
			reportType: [
				{
					name: "Last Count",
					id: "week",
					isDisabled: false
				},
				{
					name: "YTD",
					id: "week",
					isDisabled: false
				},
				{
					name: "WTD",
					id: "month",
					isDisabled: false
				},
				{
					name: "WOW",
					id: "wtd",
					isDisabled: false
				},
				{
					name: "MOM",
					id: "mtd",
					isDisabled: false
				}
			],
			location: "",
			outlets: {},
			reportTypeValue: "",
			quickReports: "sale",
			dateTo: "",
			dateFrom: "",
			datePickerOptions: {
				disabledDate: this.disabledDueDate
			},
		};
	},
	mounted() {
		EventBus.$on("changeLocationData", this.changeLocationData);
	},
	created() {
		this.params.quickReports = "sale";
		this.getOutlets({ get_all: true });
		const today = new Date();
		const yesterday = new Date(today);

		yesterday.setDate(yesterday.getDate() - 1)

		this.params.end_date = moment(yesterday).format("YYYY-MM-DD");
		this.params.start_date = moment(yesterday).format("YYYY-MM-DD");
		// this.params.start_date = "2020-04-01";
		// this.params.end_date = "2020-04-02";
	},
	methods: {
		changeLocationData(basics) {
			this.$emit("changedData", this.params, basics);
		},
		dropDownUpdate(update) {
			// this.params.quickreport = reportType;
			this.params.start_date = moment(this.params.start_date).format("YYYY-MM-DD");
			this.params.end_date =  moment(this.params.end_date).format("YYYY-MM-DD");
			this.params = {
				quickreport:this.params.quickreport,
				start_date:this.params.start_date,
				end_date:this.params.end_date,
				basics: null,
				filters:{
					outlets:[],
					subcategories:[],
					countries: [],
					regions: [],
					subregions: []
				}
			};
			// this.locationdId = update.selected.map(e => {
			// 	return e.id
			// })
			if (update.basics == "subregion") {
				this.params.filters.subregions = update.selected.map(e => {
					return e.id
				})
			} else if (update.basics == "country") {
				this.params.filters.countries = update.selected.map(e => {
					return e.id
				})
			} else if (update.basics == "region") {
				this.params.filters.regions = update.selected.map(e => {
					return e.id
				})
			} else if (update.basics == "outlet") {
				this.params.filters.outlets = update.selected.map(e => {
					return e.id
				})
			}
			this.$emit("resetBreadCurmb");
			this.$emit("handleResetPageInfoEvent");
			this.$emit("changedData", this.params, update.basics);
		},

		categoryDropdownUpdate(update) {
			// console.log(update);
			let id = update.cat_selected.map(e => {
				return e.id
			})
			this.$emit("resetBreadCurmb");
			this.$emit("handleResetPageInfoEvent");
			this.$emit("updateData", update.cat_basics, id[0], update);
		},
		changedQuickReport(reportType) {
			let start_date = moment(this.params.start_date).format("YYYY-MM-DD");
			let end_date =  moment(this.params.end_date).format("YYYY-MM-DD");

			this.params = {
				quickreport: reportType,
				start_date: start_date,
				end_date: end_date,
				basics: null,
				filters:{
					outlets:[],
					subcategories:[],
					countries: [],
					regions: [],
					subregions: []
				}
			};
			this.$emit("resetBreadCurmb");
			this.$emit("handleResetPageInfoEvent");
			this.$emit("changedData", this.params);
		},
		getOutlets(args) {
			CommonService.getOutlets(args).then(response => {
				if (response.status == 200) {
					this.outlets = JSON.parse(response.data);
				}
			});
		},
		changedDate(date) {
			this.params.start_date = moment(this.params.start_date).format("YYYY-MM-DD");
			this.params.end_date =  moment(this.params.end_date).format("YYYY-MM-DD");
			this.$emit("resetBreadCurmb");
			this.$emit("handleResetPageInfoEvent");
			this.$emit("changedData", this.params);
		},
		disabledDueDate(time) {
			if (this.params.quickReports == "week") {
				var mondays = this.getAllMondayFromYear(time);
				return !mondays.includes(moment(time).format("YYYY-MM-DD"));
			} else if (this.params.quickReports == "month") {
				var first_date = new Date(time),
					year = first_date.getYear(),
					mondays = [];
				first_date.setDate(1);
				var now = new Date();
				var next_month_firstDate = new Date(
					now.getFullYear(),
					now.getMonth() + 1,
					1
				);
				if (next_month_firstDate > first_date) {
					if (new Date(1).getDate() != time.getDate()) {
						return time.getTime();
					}
				} else {
					return time.getTime();
				}
			} else {
				return time.getTime() > Date.now() - 8.64e7;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import "./InventoryDasboardTab.scss";
/* @import "./AppSalesTabM.scss"; */
@import "../../../../../assets/css/variable.scss";
</style>
<style>
.AppSalesTab {
	margin: 0.5rem 0;
	border-radius: 4px;
}
.AppSalesTab .el-select > .el-input {
	margin-right: 5px;
}
.AppSalesTab .el-menu.el-menu--horizontal {
	border-bottom-color: 1px solid #c8c8c8 !important;
}
.AppSalesTab .el-menu--horizontal > .el-submenu .el-submenu__title {
	height: 39px;
	line-height: 42px;
	border: 1px solid #c8c8c8;
	color: #909399;
	border-radius: 4px !important;
}
.InventoryDashboard .el-input--medium {
	margin: 15px;
}
</style>
